import FormStepTypes from "./FormStepTypes";

const FormStepValidationTypes = {
  [FormStepTypes.ORGANISATION]: ["organizational", "shipment.title", "invited_modes", "quick_request.title"],
  [FormStepTypes.SCHEDULE]: ["schedule", "service.service_level"],
  [FormStepTypes.PACKING_LIST]: ["packing_list", "packing"],
  [FormStepTypes.SERVICE]: [
    "service.incoterms",
    "service.service_type",
    "service.export_clearance",
    "service.transit_clearance",
    "service.import_clearance",
  ],
  [FormStepTypes.PROVIDER]: [
    "invited_providers",
    "shipment.confirmation_date",
    "shipment.quoting_deadline_date",
    "shipment.confirmation_time",
    "shipment.quoting_deadline_time",
    "bucket_attachments",
  ],
};

export default FormStepValidationTypes;
